
import { defineComponent, ref, reactive, toRefs, onMounted, computed } from 'vue'
import { useStore } from 'vuex'

export default defineComponent({
    setup () {
        const store = useStore()

        const fields = ref<any>([
            {
                title: 'Transaction ID',
                dataIndex: 'transaction_id',
                width: 150,
                fixed: 'left'
            },
            {
                title: 'Oracle Invoice ID',
                dataIndex: 'oracle_invoice_id',
                width: 130,
                fixed: 'left'
            },
            {
                title: 'GL Date',
                dataIndex: 'gl_date',
                width: 100,
            },
            {
                title: 'PO #',
                dataIndex: 'ponumber',
                width: 100,
            },
            {
                title: 'Prepared By',
                dataIndex: 'prepared_by',
                width: 220,
            },
            {
                title: 'PV #',
                dataIndex: 'pv_number',
                width: 100,
            },
            {
                title: 'Org ID',
                dataIndex: 'org_id',
                width: 100,
            },
            {
                title: 'Type of Process',
                dataIndex: 'type_of_process',
                width: 200,
            },
            {
                title: 'Winame',
                dataIndex: 'winame',
                width: 200,
            },
            {
                title: 'Activity Name',
                dataIndex: 'activity_name',
                width: 200,
            },
            {
                title: 'Username',
                dataIndex: 'username',
                width: 220,
            },
            {
                title: 'Action',
                dataIndex: 'action',
                width: 100,
            },
            {
                title: 'Entry Datetime',
                dataIndex: 'entry_date_time',
                width: 100,
            },
            {
                title: 'Exit Datetime',
                dataIndex: 'exit_date_time',
                width: 100,
            },
        ])

        const index = (payload = {page: 1}) => {
            store.dispatch('PCRF/index', payload)
        }

        const filterRecord = (payload: any) => {
            index(payload)
        }

        onMounted(index)

        const items = computed(() => store.getters['PCRF/items'])
        const loading = computed(() => store.getters['PCRF/status'])


        return {
            fields,
            loading,
            items,
            filterRecord
        }
    }

})
